import React, { useEffect } from 'react';
import { Modal, Form, Select, Alert, Typography } from 'antd';

const { Text } = Typography;

const SolicitarMatriculaModal = ({
  open,
  turma,
  alunos = [],
  inelegiveis = [],
  avisosCadastro = [],
  submitting,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  const motivosInelegiveis = inelegiveis.flatMap((item) => item?.motivos || []);
  const motivosComunsInelegiveis = Array.from(new Set(motivosInelegiveis));
  const temMotivoComumInelegivel = inelegiveis.length > 0 && motivosComunsInelegiveis.length === 1;

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleFinish = (values) => {
    onSubmit?.(values);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      okText="Enviar solicitação"
      onOk={() => form.submit()}
      okButtonProps={{ loading: submitting, disabled: alunos.length === 0 || !turma }}
      title={turma ? `Solicitar matrícula - ${turma.nome_turm}` : 'Solicitar matrícula'}
      destroyOnClose
      width={480}
    >
      {!turma && (
        <Alert type="info" message="Selecione uma turma para iniciar a solicitação." showIcon />
      )}

      {turma && alunos.length === 0 && (
        <Alert
          type="warning"
          message="Nenhum aluno elegível disponível"
          description={
            temMotivoComumInelegivel
              ? motivosComunsInelegiveis[0]
              : (
                <div>
                  {inelegiveis.length > 0 ? (
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {inelegiveis.map((item) => (
                        <li key={item.alunoId}>
                          <strong>{item.alunoNome}:</strong> {(item.motivos || []).join(' ')}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    'Os alunos disponíveis já estão matriculados/pendentes nesta turma.'
                  )}
                </div>
              )
          }
          showIcon
        />
      )}

      {turma && avisosCadastro.length > 0 && (
        <Alert
          type="info"
          showIcon
          style={{ marginTop: 12 }}
          message="Orientações de cadastro"
          description={
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {avisosCadastro.map((item) => (
                <li key={item.alunoId}>
                  <strong>{item.alunoNome}:</strong> {(item.motivos || []).join(' ')}
                </li>
              ))}
            </ul>
          }
        />
      )}

      {turma && alunos.length > 0 && (
        <Form form={form} layout="vertical" onFinish={handleFinish} preserve={false}>
          <Form.Item
            name="alunoId"
            label="Selecione o aluno"
            rules={[{ required: true, message: 'Escolha o aluno que deseja matricular' }]}
          >
            <Select
              showSearch
              placeholder="Aluno"
              optionFilterProp="label"
              options={alunos.map((aluno) => ({
                label: aluno.nome_aluno,
                value: aluno.id,
              }))}
            />
          </Form.Item>

          <Form.Item
            name="dia_vencimento"
            label="Dia de Vencimento"
            rules={[{ required: true, message: 'Selecione o dia de vencimento' }]}
          >
            <Select
              placeholder="Selecione"
              options={[
                { label: '10', value: 10 },
                { label: '20', value: 20 },
                { label: '30', value: 30 },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="forma_pgto"
            label="Forma de Pagamento"
            rules={[{ required: true, message: 'Selecione a forma de pagamento' }]}
          >
            <Select
              placeholder="Selecione"
              options={[
                { label: 'Boleto', value: 'BOLETO' },
                { label: 'PIX', value: 'PIX' },
              ]}
            />
          </Form.Item>

          <Text type="secondary">
            A solicitação será enviada para análise do time administrativo.
          </Text>
        </Form>
      )}
    </Modal>
  );
};

export default SolicitarMatriculaModal;
